import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const examplePresents = [
  {
    title: 'Wieso? Weshalb? Warum? Adventskalender',
    productLink: "https://amzn.to/3TW4JEG",
    description: 'Ein toller Adnventskalender für Kinder.',
    imgSrc: 'https://m.media-amazon.com/images/I/811bTn3r6PL._SL1500_.jpg',
    price: '$24.99',
  },
  {
    title: "Meta Quest 3",
    productLink: "https://amzn.to/3zZbleC",
    description: "Virtual Reality Brille: Die neueste Version der Meta Quest Reihe.",
    imgSrc: "https://m.media-amazon.com/images/I/71L8CiAKL4L._SL1500_.jpg",
  },
  {
    title: "",
    productLink: "https://amzn.to/4gUYhaN",
    description: "s.Oliver Armbanduhr Damen Quarzuhr Analog, mit Edelstahl Armband, Silber,",
    imgSrc: "https://m.media-amazon.com/images/I/81jsPGNYBtL._AC_SX679_.jpg",
  }
];
  /*
  {
    title: 'Personalized Mug',
    description: 'A mug with a personalized message for your loved one.',
    imgSrc: 'https://via.placeholder.com/200x150',
    price: '$12.99',
  },
  {
    title: 'LED Light-up Teddy Bear',
    description: 'A soft teddy bear that lights up for a cozy gift.',
    imgSrc: 'https://via.placeholder.com/200x150',
    price: '$29.99',
  },
  {
    title: 'Star Map Poster',
    description: 'A custom star map showing the sky at a special moment.',
    imgSrc: 'https://via.placeholder.com/200x150',
    price: '$39.99',
  },
  {
    title: 'DIY Terrarium Kit',
    description: 'Create your own mini garden with this terrarium kit.',
    imgSrc: 'https://via.placeholder.com/200x150',
    price: '$19.99',
  },
];*/

const Inspire = ({handleChatToogle}) => {
  return (
    <Container className="mt-5">
      <h2 className="text-center mb-4 text-primary">Finde das Perfekte Geschenk!</h2>
      <p className="text-center text-muted mb-5">Lass dich von einigen Geschenken inspirieren, die andere auf dieser Seite gewählt haben.</p>

      <Row>
        {examplePresents.map((gift, index) => (
          <Col md={4} key={index} className="mb-4">
            <Card className="shadow-sm border-0 h-100" style={{ backgroundColor: '#fdf5e6' }}>
              <Card.Img variant="top" src={gift.imgSrc} alt={gift.title} />
              <Card.Body className="d-flex flex-column">
                <Card.Title className="text-primary">{gift.title}</Card.Title>
                <Card.Text className="text-muted mb-4">{gift.description}</Card.Text>
                <div className="mt-auto">
                  <Button 
                    variant="outline-primary" 
                    className="mt-2"
                    onClick={() => window.open(gift.productLink, '_blank', 'noopener,noreferrer')}
                    >
                        Learn More
                </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="text-center mt-5 mb-5 text-light">
        <Button className="text-light" variant="primary" size="lg" onClick={handleChatToogle}>Individueller</Button>
      </div>
    </Container>
  );
};

export default Inspire;